import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, GET, Adapter, POST, Body, Query } from '@royalty/httpclient';

@Injectable()
export class TaxService extends HttpService {
	/**
	 * Tax
	 */
	@GET('tax/list')
	@Adapter(null, { isAdmin: true })
	getTaxs(): Observable<any> {
		return null;
	}

	@GET('tax/getbyid')
	@Adapter(null, { isAdmin: true })
	getTax(@Query('id') id: number): Observable<any> {
		return null;
	}

	@POST('tax/create')
	@Adapter(null, { isAdmin: true })
	createTax(@Body data: string): Observable<any> {
		return null;
	}

	@POST('tax/update')
	@Adapter(null, { isAdmin: true })
	updateTax(@Body data: string): Observable<any> {
		return null;
	}

	@POST('tax/delete')
	@Adapter(null, { isAdmin: true })
	deleteTax(@Body data: string): Observable<any> {
		return null;
	}
}
